import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "./motion";
import { ArchShape, Comb, HalfCircle } from "./BrandShapes";
import { CONTACT_EMAIL } from "../lib/content";

export const ContactCTA = () => (
  <section data-testid="contact-cta" className="relative overflow-hidden bg-sage py-24 text-teal-ink sm:py-36">
    <ArchShape className="pointer-events-none absolute -bottom-10 right-[-4rem] w-72 text-teal/15 sm:w-[28rem]" strokeWidth={14} />
    <HalfCircle className="pointer-events-none absolute -top-20 left-[38%] w-48 rotate-90 text-paper/25 sm:w-72" />
    <Comb className="pointer-events-none absolute bottom-0 left-5 w-40 translate-y-1/2 text-teal/15 sm:left-12 sm:w-56" />
    <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <p className="label-caps">Let's talk</p>
      <MaskLines
        lines={["Have a crop protection", "challenge in mind?"]}
        className="mt-8 max-w-5xl font-display text-[2.4rem] font-normal leading-[1] tracking-[-0.02em] sm:text-6xl lg:text-[5.5rem]"
      />
      <Reveal className="mt-12 flex flex-col gap-6 sm:flex-row sm:items-center">
        <Link to="/contact" data-testid="cta-contact-btn" className="group label-caps inline-flex items-center gap-3 self-start rounded-full bg-teal px-8 py-4 !text-[11px] text-mist transition-colors duration-300 hover:bg-teal-ink">
          Send an enquiry <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
        </Link>
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="cta-email-link" className="link-underline self-start font-display text-xl sm:text-2xl">
          {CONTACT_EMAIL}
        </a>
      </Reveal>
    </div>
  </section>
);
